module.exports = __webpack_public_path__ + "static/images/hpjy-logo.1ef4c2e.png";